import { useMemo, useState } from 'react';
import UI from '../../ui';
import React from 'react';
import VisitedCountriesStep from './VisitedCountriesStep';
import BucketlistStep from './BucketlistStep';
import AddHotelsStep from './AddHotelsStep';
import AddContactsStep from './AddContactsStep';
import FavouriteFeaturesStep from './FavouriteFeaturesStep';
import { useNavigate } from 'react-router';
import useUserState from '../../states/useUserState';

const steps = [
  VisitedCountriesStep,
  BucketlistStep,
  AddHotelsStep,
  AddContactsStep,
  FavouriteFeaturesStep,
];

const stepsCount = steps.length;

const OnboardingPage: React.FC = () => {
  const [step, setStep] = useState(0);
  const [finished, setFinished] = useState(false);
  const { setUserId } = useUserState();

  const Component = useMemo(() => steps[step], [step]);
  const nextStep = () => setStep(prev => prev + 1);
  const prevStep = () => setStep(prev => prev - 1);

  const navigate = useNavigate();

  const Stepper: React.FC = () => {
    return (
      <UI.VerticalLayout width="100%" gap={10}>
        <UI.HorizontalLayout width="100%" justify="space-between">
          {step === 0 ? <div /> : <UI.TextButton onClick={prevStep}>Back</UI.TextButton>}
          {step === stepsCount - 1 ? <div /> : <UI.TextButton onClick={nextStep}>Skip</UI.TextButton>}
        </UI.HorizontalLayout>
        <UI.Stepper
          current={step}
          count={stepsCount}
        />
      </UI.VerticalLayout>
    );
  };

  if (finished) {
    return (
      <UI.VerticalLayout justify="center" height="100%" gap={15}>
        <UI.VerticalLayout align="center">
          <img
            style={{ maxWidth: '334px' }}
            alt="Tourist traveling with map"
            src="./assets/traveller.png"
          />
        </UI.VerticalLayout>
        <UI.VerticalLayout align="start">
          <UI.Text weight="bold" size="title">
            Your account has been created!
          </UI.Text>
          {/* <UI.Text>
            Lorem ipsum dolor sit amet
          </UI.Text> */}
        </UI.VerticalLayout>
        <UI.Button
          label="Start Browsing"
          onClick={() => {
            setUserId('4'); // 4 is "Sarah Alali's" id. If there's time, mock creating a new user
            navigate('/home');
          }}
          type="primary"
        />
      </UI.VerticalLayout>
    );
  }

  return (
    <UI.VerticalLayout height="100%" align="center" gap={10}>
      <Stepper />
      <Component skip={nextStep} />
      <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }} />
      {step === stepsCount - 1
        ? (
            <UI.Button
              label="Finish"
              onClick={() => setFinished(true)}
              width="100%"
            />
          )
        : (
            <UI.Button
              label="Next"
              onClick={nextStep}
              width="100%"
            />
          )}

    </UI.VerticalLayout>
  );
};

export default OnboardingPage;
